"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import API, { Options as APIOptions } from "@ym-framework/api-utils";
import PluginMock from "@ym-framework/api-utils-mock";
import PluginModelResponse from "@ym-framework/api-utils-model-response";
import PluginRequestIdHeader from "@ym-framework/api-utils";
import { mocks } from "@/mock";
import axios from "axios";
import { MAIN_WEBSOCKET, WEB_HTML } from "../websocketskey";
let APIUrl = "https://api.kuajingvs.com";
let MarketUrl = "https://gateway.kuajingvs.com/app-market";
let KVShopsUrl = "https://gateway.kuajingvs.com/shop-gray";
let KVVdUrl = "https://gateway.kuajingvs.com/vd-gray";
let KVNewVdUrl = "https://gateway.kuajingvs.com/pro";
let KVServiceUrl = "https://gateway.kuajingvs.com/user-device-prod";
let KVViewUrl = "https://msg.kuajingvs.com";
let KVLoginUrl = "https://gateway.kuajingvs.com/login-gray";
let KVWebRequestUrl = "https://gateway.kuajingvs.com/web-request";
let KVUpdateUrl = "https://gateway.kuajingvs.com/updates";
let KVMessageUrl = "https://iot-msg.kuajingvs.com";
if (process.env.YM_TEST === "true") {
  APIUrl = "https://test-api.kuajingvs.com";
  MarketUrl = "http://yunmai365.tpddns.cn:30800/kv/app-market-dev";
  KVShopsUrl = "https://gateway.kuajingvs.com/kv-shop-dev";
  KVVdUrl = "https://gateway.kuajingvs.com/vd-dev";
  KVNewVdUrl = "https://gateway.kuajingvs.com/kjvs/pro-dev";
  KVServiceUrl = "https://gateway-local.kuajingvs.com:30443/kv/user-online-dev";
  KVLoginUrl = "https://gateway.kuajingvs.com/kv/login-develop";
  KVWebRequestUrl = "https://gateway.kuajingvs.com/web-request-dev";
  KVUpdateUrl = "http://yunmai365.tpddns.cn:30800/kv-client-update-test";
  KVViewUrl = "https://test-msg.kuajingvs.com";
  KVMessageUrl = "https://device-online-test.kuajingvs.com";
}
if (process.env.YM_LOCAL_MOCK) {
  const _mocks = mocks;
  APIOptions.plugins.install(
    new PluginMock((mock) => {
      for (const _mock of _mocks) {
        _mock(mock);
      }
    })
  );
}
class ClientToken {
  static getToken() {
    return __async(this, null, function* () {
      yield this.getIPC();
      let _token = null;
      try {
        let response = yield axios.get(`${this.ipc}/storages/preference/token`);
        _token = response.data.value.token;
      } catch (error) {
        return null;
      }
      return _token;
    });
  }
  static getIPC() {
    return __async(this, null, function* () {
      if (this.ipc === null) {
        this.ipc = yield new Promise((resolve) => {
          if (chrome.virtualBrowserManager) {
            chrome.virtualBrowserManager.clientServer((data) => {
              resolve(data.url);
            });
          } else if (chrome.application.extension().ipc) {
            resolve(chrome.application.extension().ipc);
          } else if (chrome.clientServer()) {
            resolve(chrome.clientServer().url);
          }
        });
        return this.ipc;
      } else {
        return this.ipc;
      }
    });
  }
}
ClientToken.ipc = null;
ClientToken.getIPC();
class PluginTokenFail {
  constructor() {
    this.responseRejected = (error) => {
      if (error.hasOwnProperty("response")) {
        let code = error.response.data.errors.datas[0].code || "";
        let url = error.response.config.url || "";
        if (code === "token.error") {
          sessionStorage.setItem("tokenerror", "token.fail");
          let _ipc = ClientToken.ipc;
          if (this.$matomo) {
            this.$matomo.resetUserId();
          }
          axios.post(`${_ipc}/websockets/${MAIN_WEBSOCKET}`, {
            model: "pageEvent.logout.success",
            value: {
              message: "logout.success"
            }
          });
          axios.delete(`${_ipc}/v2/browsers`);
          axios.delete(`${_ipc}/v2/dynamic-browsers`);
          axios.delete(`${_ipc}/processes`);
          axios.delete(`${_ipc}/storages/preference/token`);
          axios.delete(`${_ipc}/storages/session/session`);
          window.open(`${WEB_HTML}/home`, "_self");
        }
      }
      return error;
    };
  }
}
APIOptions.plugins.install(new PluginTokenFail());
APIOptions.plugins.install(new PluginRequestIdHeader());
APIOptions.plugins.install(new PluginModelResponse());
APIOptions.host.set("base", () => __async(this, null, function* () {
  try {
    let version = yield API.get(`api://base.local/update/version`);
    let _version = version.data.version;
    let _arch = version.data.os.arch || "unknown";
    let _os = version.data.os.name || "unknown";
    return {
      // baseURL:"http://192.168.18.147:8888",
      // baseURL:"https://test-api.kuajingvs.com"
      // baseURL:"https://kvapi.kuajingvs.com",
      baseURL: APIUrl,
      headers: {
        "X-Patch-Ver": _version,
        "X-Client-Ver": _version,
        "X-LANG": localStorage.getItem("lang") || "zh-CN",
        platform: "pc",
        arch: _arch,
        os: _os
      }
    };
  } catch (error) {
    return {
      baseURL: APIUrl,
      headers: {
        "X-LANG": "zh-CN",
        platform: "pc"
      }
    };
  }
}));
APIOptions.host.set("base.app", () => __async(this, null, function* () {
  return {
    baseURL: APIUrl,
    headers: {
      "X-LANG": localStorage.getItem("lang") || "zh-CN",
      platform: "pc"
    }
  };
}));
APIOptions.host.set("base.auth", () => __async(this, null, function* () {
  const token = yield ClientToken.getToken();
  let version = yield API.get(`api://base.local/update/version`);
  let _version = version.data.version;
  let _arch = version.data.os.arch || "unknown";
  let _os = version.data.os.name || "unknown";
  return {
    baseURL: APIUrl,
    headers: {
      "X-Patch-Ver": _version,
      "X-Client-Ver": _version,
      "X-AUTH-TOKEN": token,
      "X-LANG": localStorage.getItem("lang") || "zh-CN",
      platform: "pc",
      arch: _arch,
      os: _os
    }
  };
}));
APIOptions.host.set("base.auth.im", () => __async(this, null, function* () {
  const token = yield ClientToken.getToken();
  return {
    baseURL: "https://im-rolling.kuajingvs.com/",
    headers: {
      "X-AUTH-TOKEN": token,
      "X-LANG": localStorage.getItem("lang") || "zh-CN"
    }
  };
}));
APIOptions.host.set("base.apps.auth", () => __async(this, null, function* () {
  const token = yield ClientToken.getToken();
  return {
    baseURL: MarketUrl,
    headers: {
      "X-LANG": localStorage.getItem("lang") || "zh-CN",
      "X-AUTH-TOKEN": token
    }
  };
}));
APIOptions.host.set("base.local", () => __async(this, null, function* () {
  const _ipc = yield ClientToken.getIPC();
  return {
    baseURL: _ipc
  };
}));
APIOptions.host.set("base.login", () => __async(this, null, function* () {
  const version = yield API.get(`api://base.local/update/version`);
  const _version = version.data.version;
  let _arch = version.data.os.arch || "unknown";
  let _os = version.data.os.name || "unknown";
  return {
    baseURL: KVLoginUrl,
    headers: {
      platform: "pc",
      "X-LANG": localStorage.getItem("lang") || "zh-CN",
      "Accept-Language": localStorage.getItem("lang") || "zh-CN",
      "X-Patch-Ver": _version,
      "X-Client-Ver": _version,
      arch: _arch,
      os: _os
    }
  };
}));
APIOptions.host.set("base.ws", () => __async(this, null, function* () {
  const _ipc = yield ClientToken.getIPC();
  const _ws = _ipc.replace("http://", "ws://");
  return {
    baseURL: _ws
  };
}));
APIOptions.host.set("base.local.token", () => __async(this, null, function* () {
  const _ipc = yield ClientToken.getIPC();
  const token = yield ClientToken.getToken();
  return {
    baseURL: _ipc,
    headers: {
      "X-AUTH-TOKEN": token
    }
  };
}));
APIOptions.host.set("base.local.auth", () => __async(this, null, function* () {
  const _ipc = yield ClientToken.getIPC();
  const token = yield ClientToken.getToken();
  return {
    baseURL: _ipc,
    // baseURL:_ipc,
    headers: {
      "client-auth-token": "main",
      "X-AUTH-TOKEN": token,
      Authorization: token
    }
  };
}));
APIOptions.host.set("base.auth.kv.vd", () => __async(this, null, function* () {
  const token = yield ClientToken.getToken();
  let version = yield API.get(`api://base.local/update/version`);
  let _version = version.data.version;
  let _arch = version.data.os.arch || "unknown";
  let _os = version.data.os.name || "unknown";
  return {
    baseURL: KVVdUrl,
    headers: {
      "X-Patch-Ver": _version,
      "X-Client-Ver": _version,
      Authorization: token,
      "X-LANG": localStorage.getItem("lang") || "zh-CN",
      "Accept-Language": localStorage.getItem("lang") || "zh-CN",
      platform: "pc",
      arch: _arch,
      os: _os
    }
  };
}));
APIOptions.host.set("base.update", () => __async(this, null, function* () {
  let version = yield API.get(`api://base.local/update/version`);
  let _version = version.data.version;
  const _osMapper = /* @__PURE__ */ new Map([
    ["Windows", "windows"],
    ["Darwin", "mac"]
  ]);
  return {
    baseURL: KVUpdateUrl,
    headers: {
      version: _version,
      platform: version.data.os.arch,
      os: _osMapper.get(version.data.os.name)
    }
  };
}));
APIOptions.host.set("base.auth.view", () => __async(this, null, function* () {
  return {
    baseURL: KVViewUrl,
    headers: {
      "X-LANG": localStorage.getItem("lang") || "zh-CN",
      platform: "pc",
      "Accept-Language": localStorage.getItem("lang") || "zh-CN"
    }
  };
}));
APIOptions.host.set("base.auth.message", () => __async(this, null, function* () {
  const token = yield ClientToken.getToken();
  let version = yield API.get(`api://base.local/update/version`);
  let _version = version.data.version;
  return {
    baseURL: KVMessageUrl,
    headers: {
      Authorization: token,
      "X-Patch-Ver": _version,
      "X-Client-Ver": _version,
      "X-LANG": localStorage.getItem("lang") || "zh-CN",
      platform: version.data.os.arch,
      "Accept-Language": localStorage.getItem("lang") || "zh-CN"
    }
  };
}));
APIOptions.host.set("base.auth.pro", () => __async(this, null, function* () {
  const token = yield ClientToken.getToken();
  let version = yield API.get(`api://base.local/update/version`);
  let _version = version.data.version;
  let _arch = version.data.os.arch || "unknown";
  let _os = version.data.os.name || "unknown";
  return {
    baseURL: KVNewVdUrl,
    headers: {
      "X-Patch-Ver": _version,
      "X-Client-Ver": _version,
      Authorization: token,
      "X-LANG": localStorage.getItem("lang") || "zh-CN",
      "Accept-Language": localStorage.getItem("lang") || "zh-CN",
      platform: "pc",
      arch: _arch,
      os: _os
    }
  };
}));
APIOptions.host.set("base.auth.pro.stream", () => __async(this, null, function* () {
  const token = yield ClientToken.getToken();
  let version = yield API.get(`api://base.local/update/version`);
  let _version = version.data.version;
  let _arch = version.data.os.arch || "unknown";
  let _os = version.data.os.name || "unknown";
  return {
    baseURL: KVNewVdUrl,
    headers: {
      "X-Patch-Ver": _version,
      "X-Client-Ver": _version,
      Authorization: token,
      "X-LANG": localStorage.getItem("lang") || "zh-CN",
      "Accept-Language": localStorage.getItem("lang") || "zh-CN",
      platform: "pc",
      arch: _arch,
      Accept: "text/event-stream",
      os: _os
    }
  };
}));
